import { Injectable } from '@angular/core';
import { GenericService, LoaderConfig } from './generic.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { ServerResponse } from '../models/ServerResponse';
import { ClientPortalUser, IClientPortalUser } from '../models/Client';
import { RequestCacheConfig } from '../models/Request';


@Injectable({
  providedIn: 'root'
})
export class ClientPortalUsersService {
  constructor(private _httpService: GenericService, private _http: HttpClient, private _authService: AuthService) { }

  getLoggedClientPortalUser(email: string, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any>> {
    return this._httpService.get<ServerResponse<any>>(`${environment.apiUrl}MVApiConsumerUsers/` + email, loaderConfig, undefined, new RequestCacheConfig(5, undefined, 'seconds'));
  }

  get currentClientPortalUser(): IClientPortalUser | undefined {
    let user: ClientPortalUser | undefined;
    let userStr: string | null = localStorage.getItem("currentClientPortalUser");
    if (userStr) {
        user = new ClientPortalUser(JSON.parse(userStr));
        return user;
    } else {
      this._authService.signout();
    }
    
    return user;
  }
}
